export const ADD_POST_FLOWS = {
  PRE_APPROVAL: "pre_approval",
  EDIT_PRE_APPROVAL: "edit_pre_approval",
};
